export const normalCourier = [
  { provider_code: "ZP", provider_name: "自配" },
  { provider_code: "ZTOKY", provider_name: "中通快运" },
  { provider_code: "YUANTONGKUAIYUN", provider_name: "圆通快运" },
  { provider_code: "YDKY", provider_name: "韵达快运" },
  { provider_code: "YMDD", provider_name: "壹米滴答" },
  { provider_code: "SX", provider_name: "顺心捷达" },
  { provider_code: "ST", provider_name: "速通物流" },
  { provider_code: "KYSY", provider_name: "跨越速运" },
  { provider_code: "HSSY", provider_name: "汇森速运" },
  { provider_code: "HUOLALAWULIU", provider_name: "货拉拉物流" },
  { provider_code: "ANE", provider_name: "安能快递" },
  { provider_code: "JTSD", provider_name: "极兔速递" },
  { provider_code: "DBL", provider_name: "德邦快递" },
  { provider_code: "UC", provider_name: "优速快递" },
  { provider_code: "SF", provider_name: "顺丰速运" },
  { provider_code: "YZPY", provider_name: "邮政快递包裹" },
  { provider_code: "YTO", provider_name: "圆通速递" },
  { provider_code: "STO", provider_name: "申通快递" },
  { provider_code: "ZTO", provider_name: "中通快递" },
  { provider_code: "DBLKY", provider_name: "德邦快运/德邦物流" },
  { provider_code: "YD", provider_name: "韵达速递" },
  { provider_code: "JD", provider_name: "京东快递" },
  { provider_code: "DNWL", provider_name: "丹鸟物流" },
  { provider_code: "BTWL", provider_name: "百世快运（查件）" }
];



// WEBPACK FOOTER //
// ./src/utils/enum.js